import {NgModule} from '@angular/core';
import {EnterpriseConfigComponent} from './enterprise-config.component';
import {EnterpriseConfigEnterpriseComponent} from './enterprise-config-enterprise/enterprise-config-enterprise.component';
import {CommonModule} from '@angular/common';
import {MaterialModule} from '../../../../../core/material';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../../../../shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import {NgZorroAntdModule, NzAutocompleteModule, NzButtonModule, NzIconModule, NzInputModule, NzPopconfirmModule, NzSpinModule, NzTabsModule} from 'ng-zorro-antd';
import {NzSelectModule} from 'ng-zorro-antd/select';
import { MatAutocompleteModule, MatButtonModule, MatButtonToggleModule, MatCardModule, MatIconModule, MatInputModule, MatProgressBarModule, MatSelectModule } from '@angular/material';
import { AddConfigIpComponent } from './add-config-ip/add-config-ip.component';
import { TextFieldModule } from '@angular/cdk/text-field';
import { AddConfigIpWithFileComponent } from './add-config-ip-with-file/add-config-ip-with-file.component';
import { NgMatAutocompleteModule } from 'src/app/shared/components/autocomplete/autocomplete.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { HotTableModule } from '@handsontable/angular';


@NgModule({
  declarations: [
    EnterpriseConfigComponent,
    EnterpriseConfigEnterpriseComponent,
    AddConfigIpComponent,
    AddConfigIpWithFileComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    TranslateModule,
    NzTabsModule,
    NzSelectModule,
    NzIconModule,
    MatButtonToggleModule,
    NzInputModule,
    NzAutocompleteModule,
    NzSpinModule,
    NzPopconfirmModule,
    NzButtonModule,
    TextFieldModule ,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatCardModule,
    MatIconModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    NgMatAutocompleteModule,
    NgxMaskModule.forChild(),
    NgxExtendedPdfViewerModule,
    NgZorroAntdModule,
    HotTableModule,
  ],
  exports: [],
  entryComponents:
  [
    AddConfigIpComponent,
    AddConfigIpWithFileComponent
  ]
})
export class EnterpriseConfigModule {}
